import React, { useState, useEffect } from 'react';
import { useClient } from '../../context/ClientContext';

export default function GeoHotspots({ dateRange }) {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetcher.fetchGeographic(dateRange)
      .then(setData)
      .finally(() => setLoading(false));
  }, [dateRange]);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="space-y-2">
          {[...Array(5)].map((_, i) => <div key={i} className="h-8 bg-gray-200 rounded"></div>)}
        </div>
      </div>
    );
  }

  if (!data?.locations?.length) return null;

  const currency = data.currency || '$';
  const maxConversions = Math.max(...data.locations.map(l => l.conversions), 1);
  const primaryColor = brand.colors?.primary || '#2563eb';

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-1"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Geographic Hotspots
      </h3>
      <p className="text-xs text-gray-400 mb-4">Where your conversions come from</p>

      <div className="space-y-2">
        {data.locations.map((loc, idx) => {
          const barWidth = maxConversions > 0 ? (loc.conversions / maxConversions) * 100 : 0;
          return (
            <div key={idx} className="flex items-center gap-3 py-1.5">
              <span className="text-xs font-bold text-gray-400 w-5 text-center">{idx + 1}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <p className="text-sm text-gray-900 truncate">{loc.name}</p>
                  <div className="flex items-center gap-3 flex-shrink-0 text-xs text-gray-500">
                    <span className="font-semibold text-gray-900">{loc.conversions} conv.</span>
                    <span>{loc.clicks} clicks</span>
                    {loc.cpa != null && <span>{currency}{loc.cpa.toFixed(0)} CPA</span>}
                  </div>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-1.5">
                  <div
                    className="h-1.5 rounded-full transition-all duration-500"
                    style={{ width: `${barWidth}%`, backgroundColor: primaryColor }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
